const NOT_NUMBER_REX = /[^0-9]/g;
const NUMBER_GROUP_REX = /.{1,3}/g;

export interface IParsedNumber {
  sign: string;
  integer: string;
  fractional: string;
}

export function parseNumber(s: string): IParsedNumber {
  const sign = s[0] === '-' ? '-' : '';
  const [integer, fractional] = s.split('.');

  return {
    fractional: fractional ? fractional.replace(NOT_NUMBER_REX, '') : '',
    integer: integer.replace(NOT_NUMBER_REX, ''),
    sign,
  };
}

/**
 * Эта штука дублирует уже существующий пакет numberToPrettyString, за исключением одной фичи:
 * эта функция принимает дополнительный необязательный параметр separator, который отделяет
 * друг от друга разряды в числах. Апгрейдить либу на данный момент разработки проекта - долгое решение.
 * Будет выполнено в техдолге CD-33162.
 */
export function getPrettyNumber(
  defaultNumber: number,
  fractionalSeparator: string = ',',
  separator: string = ' ',
): string {
  const { fractional, integer, sign } = parseNumber(String(defaultNumber));
  const parsedInteger = reverseString(integer).match(NUMBER_GROUP_REX) || [];
  const prettyInteger = parsedInteger
    .reverse()
    .map(reverseString)
    .join(separator);

  return !fractional ? `${sign}${prettyInteger}` : `${sign}${prettyInteger}${fractionalSeparator}${fractional}`;
}

function reverseString(s: string): string {
  return s
    .split('')
    .reverse()
    .join('');
}
